import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["shouldBeChoreographed", "withChoreographedRender"],
  _excluded2 = ["messageType"],
  _excluded3 = ["messageType", "messageId", "onMessageDisposition"],
  _excluded4 = ["shouldBeChoreographed", "withChoreographedToggle"],
  _excluded5 = ["messageType"],
  _excluded6 = ["messageType", "messageId", "onMessageDisposition"];
import React, { useMemo } from 'react';
import { IntegratedChoreographerMessageTypesEnum } from '../constants';
export var shouldBeChoreographed = function shouldBeChoreographed(props, coordinationOptions) {
  return Boolean(coordinationOptions === null || coordinationOptions === void 0 ? void 0 : coordinationOptions.enableChoreographer) && (props === null || props === void 0 ? void 0 : props.messageType) !== undefined && IntegratedChoreographerMessageTypesEnum.includes(props.messageType);
};
export var wrapComponentForChoreographer = function wrapComponentForChoreographer(Component) {
  var _Component$displayNam;
  function WrapperComponent(_ref) {
    var shouldBeChoreographedProp = _ref.shouldBeChoreographed,
      withChoreographedRender = _ref.withChoreographedRender,
      props = _objectWithoutProperties(_ref, _excluded);
    var ChoreographedComponent = useMemo(function () {
      return withChoreographedRender(Component);
    }, [withChoreographedRender]);
    if (shouldBeChoreographedProp(props)) {
      // Extract messageType since it is not a property of ChoreographedComponent
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var _messageType = props.messageType,
        _rest = _objectWithoutProperties(props, _excluded2);
      return /*#__PURE__*/React.createElement(ChoreographedComponent, _rest);
    }

    // Extract messageType since it is not a property of the original Atlaskit component
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _ref2 = props,
      messageType = _ref2.messageType,
      messageId = _ref2.messageId,
      onMessageDisposition = _ref2.onMessageDisposition,
      rest = _objectWithoutProperties(_ref2, _excluded3);
    return /*#__PURE__*/React.createElement(Component, rest);
  }
  WrapperComponent.displayName = "ChoreographerWrapped".concat(((_Component$displayNam = Component.displayName) !== null && _Component$displayNam !== void 0 ? _Component$displayNam : Component.name) || 'Component');
  return WrapperComponent;
};
export var wrapToggleableComponentForChoreographer = function wrapToggleableComponentForChoreographer(Component, toggleableProp) {
  var _Component$displayNam2;
  function WrapperComponent(_ref3) {
    var shouldBeChoreographedProp = _ref3.shouldBeChoreographed,
      withChoreographedToggle = _ref3.withChoreographedToggle,
      props = _objectWithoutProperties(_ref3, _excluded4);
    var ChoreographedComponent = useMemo(function () {
      return withChoreographedToggle(Component, toggleableProp);
    }, [withChoreographedToggle]);
    if (shouldBeChoreographedProp(props)) {
      // Extract messageType since it is not a property of ChoreographedComponent
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var _messageType2 = props.messageType,
        _rest2 = _objectWithoutProperties(props, _excluded5);
      return /*#__PURE__*/React.createElement(ChoreographedComponent, _rest2);
    }

    // Extract messageType since it is not a property of the original Atlaskit component
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _ref4 = props,
      messageType = _ref4.messageType,
      messageId = _ref4.messageId,
      onMessageDisposition = _ref4.onMessageDisposition,
      rest = _objectWithoutProperties(_ref4, _excluded6);
    return /*#__PURE__*/React.createElement(Component, rest);
  }
  WrapperComponent.displayName = "ChoreographerWrapped".concat(((_Component$displayNam2 = Component.displayName) !== null && _Component$displayNam2 !== void 0 ? _Component$displayNam2 : Component.name) || 'Component');
  return WrapperComponent;
};